export default "__VITE_ASSET__BERORUm0__"